import { Menu } from 'lucide-react';
import { useShell } from './ShellProvider';
import { ThemeToggle } from './ThemeToggle';
import { UserMenu } from './UserMenu';

/** Cabecera del shell: botón del menú móvil, título del sistema, tema y menú de usuario. */
export const Header = () => {
	const { setMobileOpen } = useShell();

	return (
		<header className="bg-background border-border flex h-[52px] shrink-0 items-center gap-2 border-b px-3 sm:px-4">
			<button
				type="button"
				onClick={() => setMobileOpen(true)}
				aria-label="Abrir menú"
				className="text-foreground hover:bg-accent focus-visible:outline-ring flex h-9 w-9 cursor-pointer items-center justify-center rounded-sm transition-colors focus-visible:outline-2 lg:hidden">
				<Menu
					size={20}
					aria-hidden="true"
				/>
			</button>
			<p className="text-foreground min-w-0 flex-1 truncate text-base font-semibold">
				Administración de Bienes Fiscales
			</p>
			<ThemeToggle />
			<UserMenu />
		</header>
	);
};
